import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"header d-sm-flex\">\n  {{yield}}\n</div>\n",{ moduleName: "client-portal/components/contact/contact-wrapper/header.hbs" })